export default "__VITE_ASSET__Qv77LbrY__"